/**
 * Pluginus 0.3.10.
 *
 * Copyright (c) 2008-2020 Hive Solutions Lda.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.pluginus = {}));
}(this, (function (exports) { 'use strict';

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = o[Symbol.iterator]();
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var Capability = /*#__PURE__*/function () {
    function Capability(name, properties) {
      _classCallCheck(this, Capability);

      this.name = name;
      this.properties = properties || {};
    }

    _createClass(Capability, [{
      key: "getName",
      value: function getName() {
        return this.name;
      }
    }, {
      key: "getProperties",
      value: function getProperties() {
        return this.properties;
      }
    }], [{
      key: "new",
      value: function _new(name, properties) {
        return new this(name, properties);
      }
    }]);

    return Capability;
  }();

  var Mutex = /*#__PURE__*/function () {
    function Mutex() {
      _classCallCheck(this, Mutex);

      this.acquired = false;
      this.callbacks = [];
      this.promises = [];
    }

    _createClass(Mutex, [{
      key: "acquire",
      value: function () {
        var _acquire = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this = this;

          var promise;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.acquired) {
                    _context.next = 7;
                    break;
                  }

                  promise = new Promise(function (resolve, reject) {
                    _this.callbacks.push([resolve, reject]);
                  });
                  this.promises.push(promise);
                  _context.next = 5;
                  return promise;

                case 5:
                  _context.next = 8;
                  break;

                case 7:
                  this.acquired = true;

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function acquire() {
          return _acquire.apply(this, arguments);
        }

        return acquire;
      }()
    }, {
      key: "release",
      value: function () {
        var _release = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2 = this;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(this.promises.length === 0)) {
                    _context2.next = 3;
                    break;
                  }

                  this.acquired = false;
                  return _context2.abrupt("return");

                case 3:
                  setTimeout(function () {
                    var resolve = _this2.callbacks.shift()[0];

                    _this2.promises.shift();

                    resolve();
                  });

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function release() {
          return _release.apply(this, arguments);
        }

        return release;
      }()
    }]);

    return Mutex;
  }();

  var Observable = /*#__PURE__*/function () {
    function Observable() {
      _classCallCheck(this, Observable);

      this.callbacks = {};
    }

    _createClass(Observable, [{
      key: "bind",
      value: function bind(event, callback) {
        var callbacks = this.callbacks[event] || [];
        callbacks.push(callback);
        this.callbacks[event] = callbacks;
        return callback;
      }
    }, {
      key: "unbind",
      value: function unbind(event, callback) {
        var callbacks = this.callbacks[event] || [];

        if (!callback) {
          delete this.callbacks[event];
          return;
        }

        var index = callbacks.indexOf(callback);

        if (index === -1) {
          return;
        }

        callbacks.splice(index, 1);
        this.callbacks[event] = callbacks;
      }
    }, {
      key: "trigger",
      value: function trigger(event) {
        var callbacks = this.callbacks[event] || [];
        var results = [];

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var _iterator = _createForOfIteratorHelper(callbacks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            var result = callback.apply(this, args);

            if (result !== undefined && result !== null) {
              results.push(result);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return Promise.all(results);
      }
    }]);

    return Observable;
  }();

  var version = "0.3.10";

  var PluginManager = /*#__PURE__*/function (_Observable) {
    _inherits(PluginManager, _Observable);

    var _super = _createSuper(PluginManager);

    function PluginManager(capabilities) {
      var _this;

      _classCallCheck(this, PluginManager);

      _this = _super.call(this);
      _this.version = version;
      _this.plugins = [];
      _this.pluginsName = {};
      _this.pluginsClass = {};
      _this.pluginsCapability = {};
      _this.capabilities = capabilities || ["start"];
      _this.stateMutex = new Mutex();
      return _this;
    }

    _createClass(PluginManager, [{
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _iterator, _step, capability;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iterator = _createForOfIteratorHelper(this.capabilities);
                  _context.prev = 1;

                  _iterator.s();

                case 3:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 9;
                    break;
                  }

                  capability = _step.value;
                  _context.next = 7;
                  return this.getPluginsByCapability(capability, {
                    persist: false
                  });

                case 7:
                  _context.next = 3;
                  break;

                case 9:
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);

                  _iterator.e(_context.t0);

                case 14:
                  _context.prev = 14;

                  _iterator.f();

                  return _context.finish(14);

                case 17:
                  _context.next = 19;
                  return this.restoreState();

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 11, 14, 17]]);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }, {
      key: "unload",
      value: function () {
        var _unload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _iterator2, _step2, pluginInstance;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _iterator2 = _createForOfIteratorHelper(this.plugins);
                  _context2.prev = 1;

                  _iterator2.s();

                case 3:
                  if ((_step2 = _iterator2.n()).done) {
                    _context2.next = 11;
                    break;
                  }

                  pluginInstance = _step2.value;

                  if (pluginInstance.isLoaded()) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("continue", 9);

                case 7:
                  _context2.next = 9;
                  return this.unloadPlugin(pluginInstance, false);

                case 9:
                  _context2.next = 3;
                  break;

                case 11:
                  _context2.next = 16;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](1);

                  _iterator2.e(_context2.t0);

                case 16:
                  _context2.prev = 16;

                  _iterator2.f();

                  return _context2.finish(16);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 13, 16, 19]]);
        }));

        function unload() {
          return _unload.apply(this, arguments);
        }

        return unload;
      }()
    }, {
      key: "registerPlugin",
      value: function registerPlugin(pluginClass) {
        // casts the plugin class with the proper case and
        // then creates the instance with the current manager
        // as the context argument to it
        var PluginClass = pluginClass;
        var pluginInstance = new PluginClass(this); // runs a simple "patch" operation for the plugin instances
        // that for some reason did not set the "mandatory" owner
        // field in the newly created instance

        if (pluginInstance.owner === undefined) pluginInstance.owner = this; // adds the newly crated plugin instance to the list
        // of plugins currently registered in the manager

        this.plugins.push(pluginInstance);
        this.pluginsName[pluginInstance.constructor.name] = pluginInstance;
        this.pluginsName[pluginInstance.getName()] = pluginInstance;
        this.pluginsClass[pluginClass] = pluginInstance; // iterates over the complete set of plugin's capabilities
        // to register it for all of its capabilities

        var _iterator3 = _createForOfIteratorHelper(pluginInstance.getCapabilities()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var capability = _step3.value;
            var plugins = this.pluginsCapability[capability.name] || [];
            plugins.push(pluginInstance);
            this.pluginsCapability[capability.name] = plugins;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "loadPlugin",
      value: function () {
        var _loadPlugin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(pluginInstance) {
          var persist,
              _args3 = arguments;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  persist = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;

                  if (!pluginInstance.isLoaded()) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return");

                case 3:
                  pluginInstance.ensureOwner();
                  _context3.next = 6;
                  return pluginInstance.triggerAll("before-load");

                case 6:
                  _context3.next = 8;
                  return pluginInstance.load();

                case 8:
                  _context3.next = 10;
                  return pluginInstance.triggerAll("loaded");

                case 10:
                  _context3.next = 12;
                  return pluginInstance.triggerAll("after-load");

                case 12:
                  if (persist) this.addState(pluginInstance.getName());

                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function loadPlugin(_x) {
          return _loadPlugin.apply(this, arguments);
        }

        return loadPlugin;
      }()
    }, {
      key: "unloadPlugin",
      value: function () {
        var _unloadPlugin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pluginInstance) {
          var persist,
              _args4 = arguments;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  persist = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;

                  if (pluginInstance.isLoaded()) {
                    _context4.next = 3;
                    break;
                  }

                  return _context4.abrupt("return");

                case 3:
                  pluginInstance.ensureOwner();
                  _context4.next = 6;
                  return pluginInstance.triggerAll("before-unload");

                case 6:
                  _context4.next = 8;
                  return pluginInstance.unload();

                case 8:
                  _context4.next = 10;
                  return pluginInstance.triggerAll("unloaded");

                case 10:
                  _context4.next = 12;
                  return pluginInstance.triggerAll("after-unload");

                case 12:
                  this.persistState();
                  if (persist) this.removeState(pluginInstance.getName());

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function unloadPlugin(_x2) {
          return _unloadPlugin.apply(this, arguments);
        }

        return unloadPlugin;
      }()
    }, {
      key: "ensurePluginLoaded",
      value: function () {
        var _ensurePluginLoaded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(pluginInstance) {
          var persist,
              _args5 = arguments;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  persist = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
                  _context5.next = 3;
                  return this.loadPlugin(pluginInstance, persist);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function ensurePluginLoaded(_x3) {
          return _ensurePluginLoaded.apply(this, arguments);
        }

        return ensurePluginLoaded;
      }()
    }, {
      key: "ensurePluginsLoaded",
      value: function () {
        var _ensurePluginsLoaded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(pluginInstances) {
          var persist,
              _iterator4,
              _step4,
              pluginInstance,
              _args6 = arguments;

          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  persist = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : true;
                  _iterator4 = _createForOfIteratorHelper(pluginInstances);
                  _context6.prev = 2;

                  _iterator4.s();

                case 4:
                  if ((_step4 = _iterator4.n()).done) {
                    _context6.next = 10;
                    break;
                  }

                  pluginInstance = _step4.value;
                  _context6.next = 8;
                  return this.ensurePluginLoaded(pluginInstance, persist);

                case 8:
                  _context6.next = 4;
                  break;

                case 10:
                  _context6.next = 15;
                  break;

                case 12:
                  _context6.prev = 12;
                  _context6.t0 = _context6["catch"](2);

                  _iterator4.e(_context6.t0);

                case 15:
                  _context6.prev = 15;

                  _iterator4.f();

                  return _context6.finish(15);

                case 18:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this, [[2, 12, 15, 18]]);
        }));

        function ensurePluginsLoaded(_x4) {
          return _ensurePluginsLoaded.apply(this, arguments);
        }

        return ensurePluginsLoaded;
      }()
    }, {
      key: "getPluginByName",
      value: function () {
        var _getPluginByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(name, options) {
          var load, persist, pluginInstance;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  options = options || {};
                  load = options.load === undefined ? true : options.load;
                  persist = options.persist === undefined ? true : options.persist;
                  pluginInstance = this.pluginsName[name];

                  if (pluginInstance) {
                    _context7.next = 6;
                    break;
                  }

                  return _context7.abrupt("return", null);

                case 6:
                  if (!load) {
                    _context7.next = 9;
                    break;
                  }

                  _context7.next = 9;
                  return this.ensurePluginLoaded(pluginInstance, persist);

                case 9:
                  return _context7.abrupt("return", pluginInstance);

                case 10:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function getPluginByName(_x5, _x6) {
          return _getPluginByName.apply(this, arguments);
        }

        return getPluginByName;
      }()
    }, {
      key: "getPluginByCapability",
      value: function () {
        var _getPluginByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(name, options) {
          var pluginInstances;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this.getPluginsByCapability(name, options);

                case 2:
                  pluginInstances = _context8.sent;
                  return _context8.abrupt("return", pluginInstances.length ? pluginInstances[0] : null);

                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function getPluginByCapability(_x7, _x8) {
          return _getPluginByCapability.apply(this, arguments);
        }

        return getPluginByCapability;
      }()
    }, {
      key: "getPluginsByCapability",
      value: function () {
        var _getPluginsByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(capability, options) {
          var load, persist, pluginInstances;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  options = options || {};
                  load = options.load === undefined ? true : options.load;
                  persist = options.persist === undefined ? true : options.persist;
                  pluginInstances = this.pluginsCapability[capability] || [];

                  if (!load) {
                    _context9.next = 7;
                    break;
                  }

                  _context9.next = 7;
                  return this.ensurePluginsLoaded(pluginInstances, persist);

                case 7:
                  return _context9.abrupt("return", pluginInstances);

                case 8:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function getPluginsByCapability(_x9, _x10) {
          return _getPluginsByCapability.apply(this, arguments);
        }

        return getPluginsByCapability;
      }()
    }, {
      key: "bindLoadedByCapability",
      value: function () {
        var _bindLoadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(capability, callback) {
          var plugins, _iterator5, _step5, plugin;

          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return this.getPluginsByCapability(capability, {
                    load: false
                  });

                case 2:
                  plugins = _context10.sent;
                  _iterator5 = _createForOfIteratorHelper(plugins);
                  _context10.prev = 4;

                  _iterator5.s();

                case 6:
                  if ((_step5 = _iterator5.n()).done) {
                    _context10.next = 14;
                    break;
                  }

                  plugin = _step5.value;

                  if (plugin.isLoaded()) {
                    _context10.next = 10;
                    break;
                  }

                  return _context10.abrupt("continue", 12);

                case 10:
                  _context10.next = 12;
                  return callback(plugin);

                case 12:
                  _context10.next = 6;
                  break;

                case 14:
                  _context10.next = 19;
                  break;

                case 16:
                  _context10.prev = 16;
                  _context10.t0 = _context10["catch"](4);

                  _iterator5.e(_context10.t0);

                case 19:
                  _context10.prev = 19;

                  _iterator5.f();

                  return _context10.finish(19);

                case 22:
                  this.bind("capability:".concat(capability, ":loaded"), callback);

                case 23:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[4, 16, 19, 22]]);
        }));

        function bindLoadedByCapability(_x11, _x12) {
          return _bindLoadedByCapability.apply(this, arguments);
        }

        return bindLoadedByCapability;
      }()
    }, {
      key: "unbindLoadedByCapability",
      value: function () {
        var _unbindLoadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(capability, callback) {
          return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  this.unbind("capability:".concat(capability, ":loaded"), callback);

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));

        function unbindLoadedByCapability(_x13, _x14) {
          return _unbindLoadedByCapability.apply(this, arguments);
        }

        return unbindLoadedByCapability;
      }()
    }, {
      key: "bindUnloadedByCapability",
      value: function () {
        var _bindUnloadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(capability, callback) {
          var plugins, _iterator6, _step6, plugin;

          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return this.getPluginsByCapability(capability, {
                    load: false
                  });

                case 2:
                  plugins = _context12.sent;
                  _iterator6 = _createForOfIteratorHelper(plugins);
                  _context12.prev = 4;

                  _iterator6.s();

                case 6:
                  if ((_step6 = _iterator6.n()).done) {
                    _context12.next = 14;
                    break;
                  }

                  plugin = _step6.value;

                  if (!plugin.isLoaded()) {
                    _context12.next = 10;
                    break;
                  }

                  return _context12.abrupt("continue", 12);

                case 10:
                  _context12.next = 12;
                  return callback(plugin);

                case 12:
                  _context12.next = 6;
                  break;

                case 14:
                  _context12.next = 19;
                  break;

                case 16:
                  _context12.prev = 16;
                  _context12.t0 = _context12["catch"](4);

                  _iterator6.e(_context12.t0);

                case 19:
                  _context12.prev = 19;

                  _iterator6.f();

                  return _context12.finish(19);

                case 22:
                  this.bind("capability:".concat(capability, ":unloaded"), callback);

                case 23:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this, [[4, 16, 19, 22]]);
        }));

        function bindUnloadedByCapability(_x15, _x16) {
          return _bindUnloadedByCapability.apply(this, arguments);
        }

        return bindUnloadedByCapability;
      }()
    }, {
      key: "unbindUnloadedByCapability",
      value: function () {
        var _unbindUnloadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(capability, callback) {
          return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  this.unbind("capability:".concat(capability, ":unloaded"), callback);

                case 1:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));

        function unbindUnloadedByCapability(_x17, _x18) {
          return _unbindUnloadedByCapability.apply(this, arguments);
        }

        return unbindUnloadedByCapability;
      }()
    }, {
      key: "addState",
      value: function () {
        var _addState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(name) {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context14.next = 2;
                    break;
                  }

                  return _context14.abrupt("return");

                case 2:
                  _context14.next = 4;
                  return this.stateMutex.acquire();

                case 4:
                  _context14.prev = 4;
                  _context14.next = 7;
                  return this.getState();

                case 7:
                  loadedNames = _context14.sent;

                  if (!loadedNames.includes(name)) {
                    _context14.next = 10;
                    break;
                  }

                  return _context14.abrupt("return");

                case 10:
                  loadedNames.push(name);
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 12:
                  _context14.prev = 12;
                  _context14.next = 15;
                  return this.stateMutex.release();

                case 15:
                  return _context14.finish(12);

                case 16:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this, [[4,, 12, 16]]);
        }));

        function addState(_x19) {
          return _addState.apply(this, arguments);
        }

        return addState;
      }()
    }, {
      key: "removeState",
      value: function () {
        var _removeState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(name) {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context15.next = 2;
                    break;
                  }

                  return _context15.abrupt("return");

                case 2:
                  _context15.next = 4;
                  return this.stateMutex.acquire();

                case 4:
                  _context15.prev = 4;
                  _context15.next = 7;
                  return this.getState();

                case 7:
                  loadedNames = _context15.sent;

                  if (loadedNames.includes(name)) {
                    _context15.next = 10;
                    break;
                  }

                  return _context15.abrupt("return");

                case 10:
                  loadedNames = loadedNames.splice(loadedNames.indexOf(name));
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 12:
                  _context15.prev = 12;
                  _context15.next = 15;
                  return this.stateMutex.release();

                case 15:
                  return _context15.finish(12);

                case 16:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this, [[4,, 12, 16]]);
        }));

        function removeState(_x20) {
          return _removeState.apply(this, arguments);
        }

        return removeState;
      }()
    }, {
      key: "persistState",
      value: function () {
        var _persistState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context16.next = 2;
                    break;
                  }

                  return _context16.abrupt("return");

                case 2:
                  loadedNames = this.getLoadedPlugins().map(function (p) {
                    return p.getName();
                  });
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 4:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));

        function persistState() {
          return _persistState.apply(this, arguments);
        }

        return persistState;
      }()
    }, {
      key: "restoreState",
      value: function () {
        var _restoreState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
          var loadedNames, _iterator7, _step7, loadedName;

          return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context17.next = 2;
                    break;
                  }

                  return _context17.abrupt("return");

                case 2:
                  _context17.next = 4;
                  return this.getState();

                case 4:
                  loadedNames = _context17.sent;
                  _iterator7 = _createForOfIteratorHelper(loadedNames);
                  _context17.prev = 6;

                  _iterator7.s();

                case 8:
                  if ((_step7 = _iterator7.n()).done) {
                    _context17.next = 14;
                    break;
                  }

                  loadedName = _step7.value;
                  _context17.next = 12;
                  return this.getPluginByName(loadedName);

                case 12:
                  _context17.next = 8;
                  break;

                case 14:
                  _context17.next = 19;
                  break;

                case 16:
                  _context17.prev = 16;
                  _context17.t0 = _context17["catch"](6);

                  _iterator7.e(_context17.t0);

                case 19:
                  _context17.prev = 19;

                  _iterator7.f();

                  return _context17.finish(19);

                case 22:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this, [[6, 16, 19, 22]]);
        }));

        function restoreState() {
          return _restoreState.apply(this, arguments);
        }

        return restoreState;
      }()
    }, {
      key: "getState",
      value: function () {
        var _getState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
          var loadedNamesS;
          return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context18.next = 2;
                    break;
                  }

                  return _context18.abrupt("return", []);

                case 2:
                  loadedNamesS = localStorage.getItem("pluginus:loaded");

                  if (loadedNamesS) {
                    _context18.next = 5;
                    break;
                  }

                  return _context18.abrupt("return", []);

                case 5:
                  return _context18.abrupt("return", JSON.parse(loadedNamesS));

                case 6:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));

        function getState() {
          return _getState.apply(this, arguments);
        }

        return getState;
      }()
    }, {
      key: "getLoadedPlugins",
      value: function getLoadedPlugins() {
        return this.plugins.filter(function (p) {
          return p.isLoaded();
        });
      }
    }], [{
      key: "new",
      value: function _new(capabilities) {
        return new this(capabilities);
      }
    }]);

    return PluginManager;
  }(Observable);
  var manager = new PluginManager();
  var load = function load() {
    return manager.load();
  };
  var unload = function unload() {
    return manager.unload();
  };
  var reset = function reset() {
    return manager.unload();
  };

  var camelToUnderscore = function camelToUnderscore(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
    if (!value) return value;
    return value.replace(/\.?([A-Z])/g, function (x, y) {
      return separator + y.toLowerCase();
    }).replace(RegExp("^" + separator), "");
  };
  var normalizeName = function normalizeName(name) {
    var underscore = camelToUnderscore(name, "-");
    return underscore.replace(/-plugin$/, "");
  };

  var Plugin = /*#__PURE__*/function (_Observable) {
    _inherits(Plugin, _Observable);

    var _super = _createSuper(Plugin);

    function Plugin(owner) {
      var _this;

      _classCallCheck(this, Plugin);

      _this = _super.call(this);
      _this.name = normalizeName(_this.constructor.name);
      _this.version = "0.0.0";
      _this.description = null;
      _this.owner = owner;
      _this.loaded = false;
      _this.meta = {};
      return _this;
    }

    _createClass(Plugin, [{
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.ensureOwner();
                  this.loaded = true;

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }, {
      key: "unload",
      value: function () {
        var _unload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.ensureOwner();
                  this.loaded = false;

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function unload() {
          return _unload.apply(this, arguments);
        }

        return unload;
      }()
    }, {
      key: "getPluginByCapability",
      value: function () {
        var _getPluginByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", this.owner.getPluginByCapability(name));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function getPluginByCapability(_x) {
          return _getPluginByCapability.apply(this, arguments);
        }

        return getPluginByCapability;
      }()
    }, {
      key: "getPluginsByCapability",
      value: function () {
        var _getPluginsByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(name) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", this.owner.getPluginsByCapability(name));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function getPluginsByCapability(_x2) {
          return _getPluginsByCapability.apply(this, arguments);
        }

        return getPluginsByCapability;
      }()
    }, {
      key: "getName",
      value: function getName() {
        return this.name;
      }
    }, {
      key: "getVersion",
      value: function getVersion() {
        return this.version;
      }
    }, {
      key: "getDescription",
      value: function getDescription() {
        return this.description;
      }
    }, {
      key: "getCapabilities",
      value: function getCapabilities() {
        return [];
      }
    }, {
      key: "triggerAll",
      value: function () {
        var _triggerAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(event) {
          var _this$owner;

          var promise,
              promises,
              _len,
              args,
              _key,
              _iterator,
              _step,
              _this$owner2,
              capability,
              _args5 = arguments;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  promises = []; // makes sure that there's an owner assigned to the current instance
                  // otherwise issues would arise further on

                  this.ensureOwner(); // triggers the base plugin context events both under the plugins instance
                  // and the surrounding plugin manager (as expected)

                  for (_len = _args5.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = _args5[_key];
                  }

                  promise = this.trigger.apply(this, ["plugin:".concat(this.getName(), ":").concat(event)].concat(args));
                  promises.push(promise);
                  promise = (_this$owner = this.owner).trigger.apply(_this$owner, ["plugin:".concat(this.getName(), ":").concat(event), this].concat(args));
                  promises.push(promise); // iterates over the complete set of capabilities of the current
                  // plugin to trigger capability context events both under the current
                  // instance observable and the owner's observable

                  _iterator = _createForOfIteratorHelper(this.getCapabilities());

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      capability = _step.value;
                      promise = this.trigger.apply(this, ["capability:".concat(capability.getName(), ":").concat(event)].concat(args));
                      promises.push(promise);
                      promise = (_this$owner2 = this.owner).trigger.apply(_this$owner2, ["capability:".concat(capability.getName(), ":").concat(event), this].concat(args));
                      promises.push(promise);
                    } // waits for the complete set of promises to be fulfilled so that all
                    // the async callbacks are executed (parallel execution)

                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  _context5.next = 11;
                  return Promise.all(promises);

                case 11:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function triggerAll(_x3) {
          return _triggerAll.apply(this, arguments);
        }

        return triggerAll;
      }()
    }, {
      key: "ensureOwner",
      value: function ensureOwner() {
        if (!this.isOrphan()) return;
        throw new Error("Plugin instance '".concat(this.getName(), "' is orphan of manager"));
      }
    }, {
      key: "isLoaded",
      value: function isLoaded() {
        return this.loaded;
      }
    }, {
      key: "isOrphan",
      value: function isOrphan() {
        return this.owner === undefined || this.owner === null;
      }
    }], [{
      key: "new",
      value: function _new() {
        return new this();
      }
    }, {
      key: "register",
      value: function register(owner) {
        owner = owner || manager;

        if (!owner) {
          return;
        }

        owner.registerPlugin(this);
      }
    }, {
      key: "unregister",
      value: function unregister(owner) {
        owner = owner || manager;

        if (!owner) {
          return;
        }

        owner.unregisterPlugin(this);
      }
    }]);

    return Plugin;
  }(Observable);

  exports.Capability = Capability;
  exports.Mutex = Mutex;
  exports.Observable = Observable;
  exports.Plugin = Plugin;
  exports.PluginManager = PluginManager;
  exports.camelToUnderscore = camelToUnderscore;
  exports.load = load;
  exports.manager = manager;
  exports.normalizeName = normalizeName;
  exports.reset = reset;
  exports.unload = unload;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=pluginus.umd.js.map
